define('TescoMobile_Checkout/js/view/cart/item/renderer/actions/remove',['uiComponent', 'jquery', 'Magento_Ui/js/modal/modal', 'TescoMobile_Checkout/js/model/insurance', 'mage/translate'], function (Component, $, modal, insuranceModel, $t) {
  'use strict';

  return Component.extend({
    initialize: function () {
      this._super();
      var options = {
          type: 'popup',
          modalClass: 'remove-product show-close',
          responsive: false,
          innerScroll: true,
          clickableOverlay: false,
          title: $t('Are you sure?'),
          buttons: []
        },
        modalSelector,
        itemId = this.quoteItemId,
        dataPost = this.dataPost;
      modalSelector = $('.modal-id-' + itemId);
      modal(options, modalSelector);
      $(document).on('insuranceSaved', function () {
        dataPost.data.id = insuranceModel.quoteItemId;
        $('.remove-modal-btn[rel="' + itemId + '"]').attr('rel', insuranceModel.quoteItemId);
        $('.remove-modal.modal-id-' + itemId + ' .action-delete').attr('data-post', dataPost).data('post', dataPost);
        $('.remove-modal.modal-id-' + itemId + ' .action-back').attr('rel', insuranceModel.quoteItemId);
        $('.remove-modal.modal-id-' + itemId).removeClass('modal-id-' + itemId).addClass('modal-id-' + insuranceModel.quoteItemId);
        itemId = insuranceModel.quoteItemId;
        modalSelector = $('.modal-id-' + itemId);
        modal(options, modalSelector);
      });
      $(document).ready(function () {
        $('.remove-modal-btn[rel="' + itemId + '"]').on('click', function () {
          modalSelector.modal('openModal');
        });
        $('.action-back[rel="' + itemId + '"]').on('click', function () {
          modalSelector.modal('closeModal');
        });
      });
    }
  });
});

